import { render, staticRenderFns } from "./table-associate-search.vue?vue&type=template&id=48ac07dd&scoped=true&"
import script from "./table-associate-search.vue?vue&type=script&lang=js&"
export * from "./table-associate-search.vue?vue&type=script&lang=js&"
import style0 from "./table-associate-search.vue?vue&type=style&index=0&id=48ac07dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ac07dd",
  null
  
)

export default component.exports